import { isTouchDevice } from './utilities.js' 

export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})

			button.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault()
					this.open ? this.closeNavigation() : this.openNavigation()
				}
				if (e.key === 'Escape' && this.open) {
					this.closeNavigation()
				}
			})
		})

		if (isTouchDevice()) {
			this.toggleSubmenus()
		}
	}
	openNavigation() {
		this.open = true
		document.documentElement.setAttribute('data-nav', 'open')

		this.toggle.forEach(button => {
			button.setAttribute('aria-expanded', 'true')
		})
	}
	closeNavigation() {
		this.open = false
		document.documentElement.setAttribute('data-nav', 'closed')

		this.toggle.forEach(button => {
			button.setAttribute('aria-expanded', 'false')
		})
	}
	toggleSubmenus() {
		const items = document.querySelectorAll('.header .menu li:has(ul)')

		items.forEach(item => {
			item.addEventListener('click', () => {
				item.classList.toggle('open-submenu')
			})
		})
	}
	snapCloseNavigation() {}
}

export default () => {}